<template>

    <div class="order-status">
        <div>
            <h4 class="started">Order Started</h4>
        </div>
        <div class="comment">
            <p class="timestamp">{{comment.created_at | fromNowAgo}}</p>
            <p>
                Feel free to send a message to the {{$user.isCustomer() ? 'writer' : 'customer'}}
            </p>
            <p v-if="!$user.isCustomer() && order && order.user && order.user.profile && order.user.profile.comment_from_support_to_writers">
                Comments about the customer: <br> {{order.user.profile.comment_from_support_to_writers}}
            </p>
        </div>
    </div>
</template>


<script>

    export default {
        props: ['comment', 'order'],
        data() {
            return {

            }
        },

        created(){
            this.loading = false;
        },

    }
</script>